<template>
<div
    class="tab-pane"
    :class="`${selected ? 'show active' : ''}`"
    :id="`${tab_id_computed}`"
    role="tabpanel"
    :aria-labelledby="`${tab_id_computed}-tab`"
>
    <slot />
</div>
</template>
<script>
export default {
    name: "ModalTabContent",
    props: {
        tab_id: String,
        tab_name: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        tab_id_computed() {
            return this.tab_name ?? this.tab_id;
        }
    }
}
</script>
